import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Avatar, ListItemIcon, Menu } from '@mui/material';
import { Box, Divider, IconButton, MenuItem, Typography } from '@weave-mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useAuth } from '../hooks/useAuth';
import RoleIndicator from './RoleIndicator';
function getInitials(displayName) {
    const parts = displayName.trim().split(/\s+/);
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return displayName.slice(0, 2).toUpperCase();
}
const UserMenu = () => {
    const { user, logout, viewerMode, setViewerMode } = useAuth();
    const [anchorEl, setAnchorEl] = useState(null);
    if (!user)
        return null;
    const open = Boolean(anchorEl);
    const displayName = user.name || user.email;
    const initials = getInitials(displayName);
    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleToggleViewerMode = () => {
        setViewerMode(!viewerMode);
        handleClose();
    };
    const handleLogout = () => {
        handleClose();
        logout();
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: handleOpen, sx: { p: 0.5 }, "aria-label": "user menu", children: _jsx(Avatar, { sx: {
                        width: 32,
                        height: 32,
                        bgcolor: 'primary.main',
                        fontSize: '0.8rem',
                        fontWeight: 700,
                    }, children: initials }) }), _jsxs(Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, slotProps: { paper: { sx: { minWidth: 220, mt: 0.5 } } }, children: [_jsxs(Box, { sx: { px: 2, py: 1.5, userSelect: 'none', pointerEvents: 'none' }, children: [_jsx(Typography, { variant: "subtitle2", fontWeight: "bold", noWrap: true, children: displayName }), _jsx(Box, { sx: { mt: 0.75 }, children: _jsx(RoleIndicator, {}) })] }), _jsx(Divider, {}), user.role === 'admin' && (_jsxs(MenuItem, { onClick: handleToggleViewerMode, sx: { py: 1.25 }, children: [_jsx(ListItemIcon, { children: _jsx(SwapHorizIcon, { fontSize: "small" }) }), _jsx(Typography, { variant: "body2", children: viewerMode ? 'Switch to admin' : 'Switch to viewer' })] })), _jsx(Divider, {}), _jsxs(MenuItem, { onClick: handleLogout, sx: { py: 1.25 }, children: [_jsx(ListItemIcon, { children: _jsx(LogoutIcon, { fontSize: "small" }) }), _jsx(Typography, { variant: "body2", children: "Sign out" })] })] })] }));
};
export default UserMenu;
